import ImageButton from "./image-button";
import { getLocationBrowserInstruction } from "./../../utils/geolocation";
import { useState } from "react";
import Text from "../text/text";
import Image from "./../image";
import { useNavigationStore } from "@/store/navigationStore";

export default function HomeLocationButton() {
  const [toggleTooltip, setToggleTooltip] = useState(false);
  const [instruction, setInstruction] = useState("location_permission_generic");
  const [state, setState] = useState(0);
  const setUseCurrentLocation = useNavigationStore(
    (state) => state.setUseCurrentLocation
  );
  const GRANTED = 1;
  const DENIED = 2;

  const checkLocationPermission = () => {
    setToggleTooltip(!toggleTooltip);
    if (navigator.geolocation) {
      navigator.permissions.query({ name: "geolocation" });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const getUserLocation = async () => {
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(async function (result) {
          console.log("result", result);
          if (result.state === "granted") {
            setState(GRANTED);
            setUseCurrentLocation(true);
          } else {
            if (result.state === "prompt" || result.state === "denied") {
              const browserSetting = getLocationBrowserInstruction();
              setToggleTooltip(true);
              setInstruction(browserSetting);
            }
            setState(DENIED);
          }
        });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const getLocationIcon = () => {
    switch (state) {
      case GRANTED:
        return "/assets/icon_location_on.png";
      case DENIED:
        return "/assets/icon_location_off.png";
      default:
        return "/assets/icon_location.png";
    }
  };

  return (
    <div className="flex relative">
      <ImageButton
        onClick={() => checkLocationPermission()}
        src={getLocationIcon()}
        alt="settings"
        size={32}
      />
      {toggleTooltip && (
        <div className="absolute right-0 top-full mt-4 z-50 min-w-[280px]">
          <div className="bg-location-container relative">
            {/* tooltip arrow */}
            <div className="absolute -top-2 right-2 w-0 h-0 bg-location-container-arrow" />

            <div className="flex justify-between">
              <div className="flex">
                <Image
                  className="mr-[8px]"
                  src="/assets/icon_location_dark.png"
                  alt="thumbnail"
                  width={24}
                  height={24}
                />
                <Text
                  className="primary-text-dark"
                  text="location_permission"
                />
              </div>

              {state === 0 ? (
                <div onClick={() => getUserLocation()}>
                  <Text className="text-granted" text="grant" />
                </div>
              ) : (
                <Text
                  className={state === 1 ? "text-allow" : "text-denied"}
                  text={state === 1 ? "allowed" : "denied"}
                />
              )}
            </div>
            {state === 0 && (
              <Text
                size={13}
                className="primary-text-dark mt-[12px]"
                text="location_permission_desc"
              />
            )}
            {state === DENIED && (
              <Text
                size={13}
                className="primary-text-dark mt-[12px]"
                text={instruction}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
